export const selectlanguageArr = (state) => state.languageDataArr.languageArr;